import { Component, OnInit, Output, Input, EventEmitter } from "@angular/core";

import { SalesHistoryCompanySummary } from "src/app/ui/models/domains/pbm/sales-history/sales-history-company-summary";

@Component({
  selector: "sales-history-company-card",
  templateUrl: "./sales-history-company-card.component.html",
  styleUrls: ["./sales-history-company-card.component.scss"],
})
export class SalesHistoryCompanyCardComponent implements OnInit {
  @Input() salesHistoryCompanySummary: SalesHistoryCompanySummary;

  @Output() detailSalesHistory: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  detail(): void {
    this.detailSalesHistory.emit(this.salesHistoryCompanySummary.getFiscalNumber());
  }
}
